import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=be4ad86e"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be4ad86e')) {
      api.createRecord('be4ad86e', component.options)
    } else {
      api.reload('be4ad86e', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=be4ad86e", function () {
      api.rerender('be4ad86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/cash-discounts/manage.vue"
export default component.exports